// src/components/Dashboard.js
import React, { useState } from 'react';
import AddChoreForm from './AddChoreForm';
import AddActivityForm from './AddActivityForm';
import ChoreTiles from './ChoreTiles';
import WeeklyView from './WeeklyView';
import Modal from './Modal';
import AvatarButton from './AvatarButton';
import AvatarSelectionModal from './AvatarSelectionModal'; // <-- Import new component

const Dashboard = ({ user, handleLogout }) => {
  const [isChoreModalOpen, setIsChoreModalOpen] = useState(false);
  const [isActivityModalOpen, setIsActivityModalOpen] = useState(false);
  const [isAvatarModalOpen, setIsAvatarModalOpen] = useState(false); // <-- NEW State

  return (
    <div className="dashboard-container">
      
      <AvatarButton 
        user={user} 
        handleLogout={handleLogout} 
        onOpenAvatarModal={() => setIsAvatarModalOpen(true)} // <-- Pass the opener
      />

      <div className="dashboard-grid-layout">
        <div className="schedule-panel">
          <div className="panel-header">
            <h2>Weekly Schedule</h2>
            <button className="add-button" onClick={() => setIsActivityModalOpen(true)}>
              + Add Activity
            </button>
          </div>
          <WeeklyView />
        </div>

        <div className="chore-panel">
          <div className="panel-header">
            <h2>Chore Assignments</h2>
            <button className="add-button" onClick={() => setIsChoreModalOpen(true)}>
              + Add Chore
            </button>
          </div>
          <ChoreTiles />
        </div>
      </div>

      <Modal 
        isOpen={isChoreModalOpen} 
        onClose={() => setIsChoreModalOpen(false)} 
        title="Add a New Chore"
      >
        <AddChoreForm currentUser={user} onClose={() => setIsChoreModalOpen(false)} />
      </Modal>

      <Modal 
        isOpen={isActivityModalOpen} 
        onClose={() => setIsActivityModalOpen(false)} 
        title="Add an Activity/Appointment"
      >
        <AddActivityForm onClose={() => setIsActivityModalOpen(false)} />
      </Modal>

      {/* NEW: Modal for Avatar Selection */}
      <Modal
        isOpen={isAvatarModalOpen}
        onClose={() => setIsAvatarModalOpen(false)}
        title="Choose Your Avatar"
      >
        <AvatarSelectionModal user={user} onClose={() => setIsAvatarModalOpen(false)} />
      </Modal>

    </div>
  );
};

export default Dashboard;